export class StravaConfig {
    static access_token:string  = `0dcda3ab8bc70a29d2501ab29b2718a71895c9f6`;
    static client_id:string =  `65569`;
    static client_secret:string =  `e40ff819f2fc2a69707c32ec95799c0f93b3f0f5`;
    //static redirect_url:string =  `https://bingo.scott64.com`;
    static redirect_url:string =  `http://127.0.0.1:3000`;
}